import React from "react";
import { NumericFormat } from "react-number-format";

import RefundService from "../../../services/Gowd/refundService";
import { getReceivedAmount } from "../../../utils/refund";

const REFUND_REASONS = [
  { code: "MD06", label: "Devolução solicitada pelo cliente" },
  { code: "AM09", label: "Valor recebido incorreto" },
  { code: "FR01", label: "Suspeita de fraude" },
];

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const boxStyle = {
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "24px",
  minWidth: "360px",
  maxWidth: "90%",
  boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  color: "#666",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  fontSize: "15px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  outline: "none",
  boxSizing: "border-box",
};

function formatToBRL(number) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number);
}

class RefundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    return {
      step: 0,
      amount: "",
      refundCode: REFUND_REASONS[0].code,
      refundReason: "",
      twoFactorCode: "",
      loading: false,
      error: "",
    };
  }

  componentDidUpdate(prevProps) {
    // Cada abertura recomeça do zero: reaproveitar o valor digitado de um
    // lançamento anterior devolveria o valor errado.
    if (this.props.open && !prevProps.open) {
      this.setState({
        ...this.initialState(),
        amount: String(getReceivedAmount(this.props.item)),
      });
    }
  }

  close = () => {
    if (this.state.loading) {
      return;
    }
    this.props.onClose();
  };

  parsedAmount() {
    const parsed = Number(String(this.state.amount || "").replace(",", "."));
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  validationError() {
    const amount = this.parsedAmount();
    const received = getReceivedAmount(this.props.item);

    if (amount <= 0) {
      return "Informe um valor maior que zero.";
    }
    if (amount > received) {
      return `O valor da devolução não pode ultrapassar ${formatToBRL(received)}.`;
    }
    return "";
  }

  goToConfirmation = () => {
    const error = this.validationError();
    if (error) {
      this.setState({ error });
      return;
    }
    this.setState({ step: 1, error: "", twoFactorCode: "" });
  };

  submit = () => {
    const { item } = this.props;
    const error = this.validationError();
    if (error) {
      this.setState({ step: 0, error });
      return;
    }

    this.setState({ loading: true, error: "" });

    RefundService.create({
      orderId: item?.order_id,
      amount: this.parsedAmount(),
      refundCode: this.state.refundCode,
      refundReason:
        this.state.refundReason ||
        REFUND_REASONS.find((r) => r.code === this.state.refundCode)?.label,
      description: `Devolução de Pix ${item?.end_to_end_id || item?.order_id || ""}`.trim(),
      twoFactorCode: this.state.twoFactorCode || undefined,
    })
      .then((res) => {
        this.setState({ loading: false });
        this.props.onSuccess(res?.data?.body || res?.data || {});
      })
      .catch((err) => {
        console.error(err);
        const data = err?.response?.data;
        const message =
          (typeof data === "string" && data) ||
          data?.message ||
          data?.title ||
          err?.message ||
          "Não foi possível concluir a devolução.";
        this.setState({ loading: false, step: 1, error: message });
      });
  };

  handleTwoFactorChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    this.setState({ twoFactorCode: value });
  };

  handleEnterOnCode = (e) => {
    if (e.key === "Enter" && this.state.twoFactorCode.length === 6) {
      this.submit();
    }
  };

  renderError() {
    if (!this.state.error) {
      return null;
    }
    return (
      <p
        style={{
          fontSize: "13px",
          color: "#c0392b",
          marginTop: "12px",
        }}
      >
        {this.state.error}
      </p>
    );
  }

  renderForm() {
    const { item } = this.props;
    const received = getReceivedAmount(item);
    const payer = item?.payer_name || item?.customer_name || "--";
    const amount = this.parsedAmount();
    const isPartial = amount > 0 && amount < received;

    return (
      <div style={boxStyle}>
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "4px",
            color: "#333",
          }}
        >
          Devolver Pix recebido
        </h3>
        <p style={{ fontSize: "14px", color: "#666", marginBottom: "16px" }}>
          Recebido de <b>{payer}</b> — {formatToBRL(received)}
        </p>

        <label htmlFor="refundAmount" style={labelStyle}>
          Valor a devolver
        </label>
        <NumericFormat
          id="refundAmount"
          style={inputStyle}
          value={this.state.amount}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          fixedDecimalScale
          prefix="R$ "
          disabled={this.state.loading}
          onValueChange={(values) =>
            this.setState({ amount: values.value, error: "" })
          }
        />

        <button
          type="button"
          onClick={() => this.setState({ amount: String(received), error: "" })}
          style={{
            background: "none",
            border: "none",
            color: "#1c787e",
            fontSize: "13px",
            padding: "8px 0 0 0",
            cursor: "pointer",
          }}
        >
          Devolver o valor total
        </button>

        <div style={{ marginTop: "16px" }}>
          <label htmlFor="refundCode" style={labelStyle}>
            Motivo
          </label>
          <select
            id="refundCode"
            style={inputStyle}
            value={this.state.refundCode}
            disabled={this.state.loading}
            onChange={(e) => this.setState({ refundCode: e.target.value })}
          >
            {REFUND_REASONS.map((reason) => (
              <option key={reason.code} value={reason.code}>
                {reason.label}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginTop: "16px" }}>
          <label htmlFor="refundReason" style={labelStyle}>
            Observação (opcional)
          </label>
          <input
            id="refundReason"
            type="text"
            style={inputStyle}
            maxLength={140}
            value={this.state.refundReason}
            disabled={this.state.loading}
            onChange={(e) => this.setState({ refundReason: e.target.value })}
          />
        </div>

        {isPartial && (
          <p style={{ fontSize: "13px", color: "#666", marginTop: "12px" }}>
            Devolução parcial: {formatToBRL(received - amount)} permanecem na
            conta.
          </p>
        )}

        {this.renderError()}

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <button
            onClick={this.close}
            style={{
              backgroundColor: "white",
              border: "1px solid #aaa",
              color: "#555",
              borderRadius: "6px",
              padding: "10px 20px",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={this.goToConfirmation}
            style={{
              backgroundColor: "#1c787e",
              border: "none",
              color: "white",
              borderRadius: "6px",
              padding: "10px 20px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Continuar
          </button>
        </div>
      </div>
    );
  }

  renderConfirmation() {
    const disabled = this.state.loading || this.state.twoFactorCode.length !== 6;

    return (
      <div style={boxStyle}>
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "4px",
            color: "#333",
          }}
        >
          Confirmar devolução
        </h3>
        <p style={{ fontSize: "14px", color: "#666" }}>
          Você vai devolver <b>{formatToBRL(this.parsedAmount())}</b> para{" "}
          <b>{this.props.item?.payer_name || "o pagador"}</b>.
        </p>
        <p style={{ fontSize: "14px", color: "#666", marginTop: "16px" }}>
          Digite o código de 6 dígitos do seu aplicativo autenticador:
        </p>

        <input
          type="text"
          value={this.state.twoFactorCode}
          onChange={this.handleTwoFactorChange}
          onKeyDown={this.handleEnterOnCode}
          maxLength="6"
          placeholder="000000"
          aria-label="Código de autenticação"
          disabled={this.state.loading}
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "18px",
            textAlign: "center",
            letterSpacing: "4px",
            border: "2px solid #ddd",
            borderRadius: "6px",
            margin: "16px 0",
            outline: "none",
            boxSizing: "border-box",
          }}
        />

        {this.renderError()}

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <button
            onClick={() => this.setState({ step: 0, error: "" })}
            disabled={this.state.loading}
            style={{
              backgroundColor: "white",
              border: "1px solid #aaa",
              color: "#555",
              borderRadius: "6px",
              padding: "10px 20px",
              cursor: this.state.loading ? "not-allowed" : "pointer",
              opacity: this.state.loading ? 0.6 : 1,
            }}
          >
            Voltar
          </button>
          <button
            onClick={this.submit}
            disabled={disabled}
            style={{
              backgroundColor: disabled ? "#ccc" : "#1c787e",
              border: "none",
              color: "white",
              borderRadius: "6px",
              padding: "10px 20px",
              cursor: disabled ? "not-allowed" : "pointer",
              fontWeight: "bold",
            }}
          >
            {this.state.loading ? "Devolvendo..." : "Confirmar devolução"}
          </button>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.open || !this.props.item) {
      return null;
    }

    return (
      <div style={overlayStyle}>
        {this.state.step === 0 ? this.renderForm() : this.renderConfirmation()}
      </div>
    );
  }
}

export default RefundModal;
